import ftpRepository from '@/api/ftpRepository'
import ObjectRepository from './objectsRepository'
import AuthRepository from './authRepository'
import groupRepository from './groupRepository'
import actionRepository from './actionRepository'
import tagRepository from './tagRepository'
import tenantRepository from './tenantRepository'
import bulkDownloadRepository from './bulkDownloadRepository'

const repositories = {
  objects: ObjectRepository,
  auth: AuthRepository,
  group: groupRepository,
  action: actionRepository,
  tag: tagRepository,
  tenant: tenantRepository,
  ftp: ftpRepository,
  bulkDownload: bulkDownloadRepository,
  // register more repositories here
}

// eslint-disable-next-line import/prefer-default-export
export const RepositoryFactory = {
  get: name => repositories[name],
}
